export const PageHero = ({ eyebrow, title, accent, subtitle }) => (
    <section className="relative bg-navy-900 text-white pt-32 md:pt-40 pb-16 md:pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-hero-radial" />
        <div className="absolute inset-0 bg-gradient-to-br from-navy-950 via-navy-900 to-navy-800/80" />
        <div className="relative container-px mx-auto max-w-7xl">
            {eyebrow && (
                <p className="text-sm font-semibold text-accent uppercase tracking-[0.2em] mb-4">{eyebrow}</p>
            )}
            <h1 className="text-display-xl font-display mb-5 max-w-3xl">
                {title}
                {accent && <> <span className="text-accent">{accent}</span></>}
            </h1>
            {subtitle && (
                <p className="text-lg md:text-xl text-steel-200 leading-relaxed max-w-2xl">{subtitle}</p>
            )}
        </div>
    </section>
);
